export default "__VITE_ASSET__JToRaSqa__"